import React from 'react'
import Link from 'gatsby-link'

import './header.scss';

const Header = ({ siteTitle }) => (
  <div className="header-container">
    <div className="inner">
      <div className="logo">
        <Link to="/">
          {siteTitle}
        </Link>
      </div>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header/header.js